/*
 *
 * InitiateRefundModalV2 constants
 *
 */

const BASE_CONSTANT = 'app/InitiateRefundModalV2';

export const DEFAULT_ACTION = `${BASE_CONSTANT}/DEFAULT_ACTION`;

export const CREATE_REFUND = `${BASE_CONSTANT}/CREATE_REFUND`;

export const VENDOR_DATA = `${BASE_CONSTANT}/VENDOR`;

export const ENABLE_LOADER = `${BASE_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_CONSTANT}/DISABLE_LOADER`;

export const SAVE_VENDORS_RESPONSE = `${BASE_CONSTANT}/SAVE_VENDORS_RESPONSE`;

export const MAXIMUM_REFUND_AMOUNT = `${BASE_CONSTANT}/MAXIMUM_REFUND_AMOUNT`;

export const SAVE_MAXIMUM_REFUND_AMOUNT = `${BASE_CONSTANT}/SAVE_MAXIMUM_REFUND_AMOUNT`;

export const RESET_MODAL_DATA = `${BASE_CONSTANT}/RESET_MODAL_DATA`;

export const INSTANT_REFUND_ELIGIBILITY = `${BASE_CONSTANT}/INSTANT_REFUND_ELIGIBILITY`;

export const GET_WALLET_STATUS = `${BASE_CONSTANT}/GET_WALLET_STATUS`;

export const GET_RECHARGE_ACCOUNT_DETAILS = `${BASE_CONSTANT}/GET_RECHARGE_ACCOUNT_DETAILS`;

export const CREATE_INSTANT_REFUNDS_FREE_TRIAL_WALLET = `${BASE_CONSTANT}/CREATE_INSTANT_REFUNDS_FREE_TRIAL_WALLET`;

export const UPDATE_DEFAULT_REFUND_SPEED = `${BASE_CONSTANT}/UPDATE_DEFAULT_REFUND_SPEED`;

export const INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE';

export const INITIATE_REFUND = 'INITIATE_REFUND';

export const RECHARGE_PENDING = 'RECHARGE_PENDING';

export const STOPWATCH_ICON_URL =
  'https://cashfreelogo.cashfree.com/website/pg/od-settlements-assets/stopwatch.svg';

export const CREATE_REFUND_URL = {
  method: 'POST',
  url: '/pg/refund/new',
};

export const MAXIMUM_REFUND_URL = {
  url: `/pg/transaction/$tx_id$/refundable-amount`,
  method: 'GET',
};

export const INSTANT_REFUND_ELIGIBILITY_URL = {
  method: 'GET',
  url: '/pg/refund/instant-refunds/eligibility',
};

export const WALLET_STATUS_ACTIVE = 'ACTIVE';

export const ELIGIBLE_REFUND_AMOUNT_BREAKDOWN = [
  {
    key: 'transactionAmount',
    display: 'Transaction Amount',
  },
  {
    key: 'disputedAmount',
    display: 'Disputed Amount',
    isNegative: true,
  },
  {
    key: 'refundedAmount',
    display: 'Refunded Amount',
    isNegative: true,
  },
  {
    key: 'maximumRefundAmount',
    display: 'Eligible Refund Amount',
  },
];

export const INSTANT_REFUND_CHARGES_BREAKDOWN = [
  {
    key: 'refundAmount',
    display: 'Refund Amount',
  },
  {
    key: 'serviceFee',
    display: 'Instant Refund Fee',
  },
  {
    key: 'tax',
    display: 'Taxes',
  },
  {
    key: 'totalAmount',
    display: 'Total amount to be deducted',
  },
];
